import { ReactElement } from 'react'
import strings from '../../../../../locale/en'
import {
  ActionButton,
  CardHeader,
  FlexWrapper,
  PageWrapper,
  Button,
  SectionTitle
} from '../../../../../components'
import PersonalDetails from './PersonalDetails'
import { CardWrapper } from './subcomponents'
import CommunicationDetails from './CommunicationDetails'
import QualifyingExamDetails from './QualifyingExamDetails'
import CourseDetails from './CourseDetails'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { addNewStudentDetails } from '../../../../../redux/userDetail/api'

const Register = (): ReactElement => {
  const history = useHistory()
  const dispatch = useDispatch()
  const {
    studentDetails: {
      addRegistrationForm,
      courseDetailsTitle,
      personalDetailsTitle,
      communictionDetailsTitle,
      qualifyingExamDetailsTitle
    },
    button: { save, back }
  } = strings
  return (
    <PageWrapper id="container">
      <FlexWrapper hasBorder>
        <SectionTitle title={addRegistrationForm} />
      </FlexWrapper>
      <CardWrapper>
        <CardHeader>{courseDetailsTitle}</CardHeader>
        <CourseDetails />
      </CardWrapper>
      <CardWrapper>
        <CardHeader>{personalDetailsTitle}</CardHeader>
        <PersonalDetails />
      </CardWrapper>
      <CardWrapper>
        <CardHeader>{communictionDetailsTitle}</CardHeader>
        <CommunicationDetails />
      </CardWrapper>
      <CardWrapper>
        <CardHeader>{qualifyingExamDetailsTitle}</CardHeader>
        <QualifyingExamDetails />
      </CardWrapper>
      <FlexWrapper justifyContent="center">
        <ActionButton
          variant="outline-secondary"
          onClick={() => {
            history.goBack()
          }}
        >
          {back}
        </ActionButton>
        <Button onClick={() => {
          dispatch(addNewStudentDetails())
        }}>{save}</Button>
      </FlexWrapper>
    </PageWrapper>
  )
}

export default Register
